exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".faq-section .content-section{max-width:600px;z-index:1}.faq-section .content-section .expansionDiv{margin-top:-15px}.faq-section .content-section .expansionDiv .expansion-panel{background-color:rgba(0,0,0,0);box-shadow:none;width:100%}.faq-section .content-section .expansionDiv .expansion-panel .expansion-panel-summary{flex-direction:row-reverse}.faq-section .content-section .expansionDiv .expansion-panel li{font-weight:300}.faq-section .question{font-weight:500}.faq-section .answer{padding-left:10px;color:#555}.faq-section .leftIconAnswer{padding-left:48px;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ProductLanding/FAQ.scss
// module id = 7559
// module chunks = 101